<div class="font-medium text-[#7b7b7b] text-xs leading-4">
  @for (item of legalTextData().text; track $index) {
    <p class="m-0">
      @for (part of parseText(item); track $index) {
        @if (!isLink(part)) {
          {{ part }}
        } @else {
          <a [href]="part?.href" [target]="part?.target">{{ part?.text }}</a>
        }
      }
    </p>
    <br />
  }
</div>
